export default {
  namespaced:true,
  state: 
  {
    idEmpresa:    localStorage.getItem('idEmpresa') || '' ,
    clientSecret: localStorage.getItem('clientSecret') || '' ,
    reload: false, 
        backColorGradient1: '#009f5a' ,
        backColorGradient2: '#18d699' , 
        headerSeparatorColor : '#009f5a' ,
        formBtnActionColor: '#005a9f' ,
        formBtnCancelColor: '#5c666f' ,
        btnActionColor: '#44C7F4' ,
        btnCancelColor: '#4969B2' 
    },

    mutations: 
    {
      save (state, entorno) 
      {
        state.idEmpresa = entorno.idEmpresa
        state.clientSecret = entorno.clientSecret
        localStorage.setItem("idEmpresa", entorno.idEmpresa);
        localStorage.setItem("clientSecret", entorno.clientSecret);
      },

      delete (state) 
      {
        state.idEmpresa = null
        state.clientSecret = null
        localStorage.removeItem("idEmpresa");
        localStorage.removeItem("clientSecret");
      },


      reload (state,flag) 
      {
        state.reload = flag;
      }


    }

}



// WEBPACK FOOTER //
// ./src/store/modules/entorno.js